<template>
  <section class="section">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Department of Agri Product Sale and Marketing/ Online Market
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 6 || roleid == 7">
        <b-tab-item label="ຕະຫຼາດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາຍການຕະຫຼາດ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ຊື່ຕະຫຼາດ
                      </th>
                      <th class="has-text-left " width="15%">
                        ແຂວງ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເມືອງ
                      </th>
                      <th class="has-text-left " width="15%">
                        ບ້ານ
                      </th>
                      <th class="has-text-centered " width="30%">
                        ລາຍການສັ່ງຊື້
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in marketlist" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.MARTKETNAME }}
                      </td>
                      <td>
                        {{ data.PROVINCENAME }}
                      </td>
                      <td>
                        {{ data.DISTRICT }}
                      </td>
                      <td>
                        {{ data.VILLAGE }}
                      </td>

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                openOderlistTab(data.ID, data.MARTKETNAME)
                              "
                              >ລາຍລະອຽດ
                            </b-button>
                          </b-field>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="ລາຍການສັ່ງຊື້">
          <b-field v-if="marketname === null">
            <button class="button is-info" @click="gotomarketlist">
              ເລືອກ Order ກ່ອນ
            </button>
          </b-field>
          <b-field v-else>
            <div class="container">
              <div class="columns">
                <div class="column">
                  <h3 class="title">{{ marketname }}</h3>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-button
                    class="btn-group-margin"
                    type="is-primary"
                    @click="combineOrders()"
                    >ລວມອໍເດີ້ ເພື່ອຈັດຊື້
                  </b-button>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <table width="100%" class="table ">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">
                          #
                        </th>
                        <th class="has-text-left " width="5%">
                          ເລືອກ
                        </th>
                        <th class="has-text-left " width="30%">
                          ລະຫັດສັ່ງຊື້
                        </th>
                        <th class="has-text-left" width="60%">
                          ລາຍການທີ່ສັ່ງ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in orderlist"
                        :key="data.ORDERID"
                      >
                        <td
                          class="has-text-centered"
                          v-if="data.STATUS === null"
                        >
                          {{ index + 1 }}
                        </td>
                        <td
                          class="has-text-centered"
                          v-if="data.STATUS === null"
                        >
                          <b-checkbox v-model="data.selectedorderlist">
                          </b-checkbox>
                        </td>

                        <td v-if="data.STATUS === null">
                          ລະຫັດສັ່ງຊື້: {{ data.ORDERID }} <br />

                          {{ data.FULLNAME }}
                          <br />
                          {{ data.PHONENO }}<br />
                        </td>
                        <td class="has-text-left" v-if="data.STATUS === null">
                          <table width="100%">
                            <thead>
                              <tr>
                                <td>ສິນຄ້າ</td>
                                <td>ຈຳນວນ</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="detail in orderdertaillist"
                                :key="detail.ID + '-' + detail.ORDERID"
                              >
                                <td v-if="detail.ORDERID === data.ORDERID">
                                  {{ detail.PRODUCTID }}
                                  {{ detail.PRODUCTNAME_SUB }}
                                </td>
                                <td v-if="detail.ORDERID === data.ORDERID">
                                  {{ detail.STANDARDQUANTITY }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </b-field>
        </b-tab-item>

        <b-tab-item label="ລາຍການກະກຽມສິນຄ້າ">
          <b-field v-if="1 === 0">
            <button class="button is-info" @click="gotomarketlist">
              ເລືອກ Order ກ່ອນ
            </button>
          </b-field>
          <b-field v-else>
            <div class="container">
              <div class="columns">
                <div class="column">
                  <h3 class="title">
                    {{ marketname }}
                  </h3>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="ລາຍການຈັດຊື້">
                    <table width="100%" class="table ">
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="5%">
                            #
                          </th>
                          <th class="has-text-left " width="30%">
                            ເລກທີກະກຽມ
                          </th>
                          <th class="has-text-left" width="65%">
                            ສິນຄ້າຫຼັກ
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(prepare, index) in preparelist"
                          :key="prepare.ID"
                        >
                          <td class="has-text-centered">
                            {{ index + 1 }}
                          </td>
                          <td class="has-text-left">
                            {{ prepare.ID }} <br /><br />
                            orderid: {{ prepare.ORDRERIDLIST }} <br /><br />
                            <button
                              class="button is-success is-small"
                              @click="printReceipt(prepare.ID)"
                            >
                              ກຽມພິມໃບຈັດຊື້
                            </button>
                            <br /><br />
                            
                            <button
                              v-if="prepare.STATUS == 1"
                              class="button is-info is-small"
                              @click="completeCombineOrders(prepare.ID)"
                            >
                              ຈັດຊື້ສຳເລັດ</button
                            ><br /><br />
                            <button
                              v-if="prepare.STATUS == 1"
                              class="button is-warning is-small"
                              @click="cancelCombineOrders(prepare.ID)"
                            >
                              ຍົກເລີກການຈັດຊື້</button
                            ><br /><br />
                            <button
                              v-if="prepare.STATUS == 1"
                              class="button is-danger is-small"
                              @click="cancelCombineOrdersForever(prepare.ID)"
                            >
                              ຍົກເລີກການຈັດຊື້ຖາວອນ
                            </button>
                          </td>
                          <td class="has-text-centered">
                            <table
                              class="table is-fullwidth is-narrow is-small"
                            >
                              <thead>
                                <tr>
                                  <td width="35%">ສິນຄ້າ</td>
                                  <td width="65%">ສິນຄ້າຍ່ອຍ</td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="combine in combineorder"
                                  :key="combine.PRODUCTID"
                                >
                                  <td v-if="combine.PREPAREID === prepare.ID">
                                    {{ combine.PRDODUCTNAME }} <br>
                                    <b-field v-if="combine.TOTALCOM" style="color:red; font-weight: bold;">   {{ combine.TOTAL | formatNumberLocal}}</b-field>
                                    <b-field v-else-if="!combine.TOTALCOM">
                                      <b-input type="number" placeholder="ຈຳນວນເງິນ" v-model.trim="combine.TOTAL"></b-input>
                                    </b-field>
                                    
                                  </td>

                                  <td
                                    class="has-text-centered"
                                    v-if="combine.PREPAREID === prepare.ID"
                                  >
                                    <table
                                      class="table is-fullwidth is-narrow is-small"
                                    >
                                      <thead>
                                        <tr>
                                          <th
                                            class="has-text-left "
                                            width="60%"
                                          >
                                            ສິນຄ້າຍ່ອຍ
                                          </th>
                                          <th
                                            class="has-text-right"
                                            width="40%"
                                          >
                                            ຈຳນວນ
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr
                                          v-for="combinedetail in combineorderdetail"
                                          :key="combinedetail.DETAILID"
                                        >
                                          <td
                                            v-if="
                                              prepare.ID ===
                                                combinedetail.PREPAREID &&
                                                combine.PREPAREID ===
                                                  prepare.ID &&
                                                combinedetail.PRODUCTID ===
                                                  combine.PRODUCTID
                                            "
                                          >
                                            {{ combinedetail.PRODUCTNAME_SUB }}
                                          </td>
                                          <td
                                            class="has-text-right"
                                            v-if="
                                              prepare.ID ===
                                                combinedetail.PREPAREID &&
                                                combine.PREPAREID ===
                                                  prepare.ID &&
                                                combinedetail.PRODUCTID ===
                                                  combine.PRODUCTID
                                            "
                                          >
                                            ລວມ: {{ combinedetail.QUANTITY }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            colspan="2"
                                            class="has-text-right"
                                          >
                                            {{ combine.QUANTITY }}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                
                              </tbody>
                            </table>
                            <b-field style="float: left;">
                              <button v-if="!combineorder[0].TOTALCOM"
                                class="button is-info"
                                @click="saveTotal(prepare.ID)"
                              >
                                ບັນທຶກລາຄາຊື້
                              </button>
                              <button v-else-if="combineorder[0].TOTAL"
                                class="button is-warning"
                                @click="cancelTotal(prepare.ID)"
                              >
                                ຍົກເລີກລາຄາຊື້
                              </button>
                            </b-field>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3"><hr /></td>
                        </tr>
                      </tbody>
                    </table>
                  </b-field>
                </div>
              </div>
            </div>
          </b-field>
        </b-tab-item>
        <b-tab-item label="ລາຍການຈັດຊື້ສຳເລັດ">
          <b-field v-if="1 === 0">
            <button class="button is-info" @click="gotomarketlist">
              ເລືອກ Order ກ່ອນ
            </button>
          </b-field>
          <b-field v-else>
            <div class="container">
              <div class="columns">
                <div class="column">
                  <h3 class="title">
                    {{ marketname }}
                  </h3>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="ລາຍການຈັດຊື້ສຳເລັດ">
                    <table width="100%" class="table ">
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="5%">
                            #
                          </th>
                          <th class="has-text-left " width="30%">
                            ເລກທີກະກຽມ
                          </th>
                          <th class="has-text-left" width="65%">
                            ສິນຄ້າຫຼັກ
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(prepare, index) in completepreparelist"
                          :key="prepare.ID"
                        >
                          <td class="has-text-centered">
                            {{ index + 1 }}
                          </td>
                          <td class="has-text-left">
                            {{ prepare.ID }} <br /><br />
                            orderid: {{ prepare.ORDRERIDLIST }}
                          </td>
                          <td class="has-text-centered">
                            <table
                              class="table is-fullwidth is-narrow is-small"
                            >
                              <thead>
                                <tr>
                                  <td width="35%">ສິນຄ້າ</td>
                                  <td width="65%">ສິນຄ້າຍ່ອຍ</td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="combine in completecombineorder" 
                                  :key="combine.PRODUCTID"
                                >
                                  <td v-if="combine.PREPAREID === prepare.ID">
                                    {{ combine.PRDODUCTNAME }}<br>
                                    <b-field style="color:red; font-weight: bold;">   {{ combine.TOTAL | formatNumberLocal}} </b-field>
                                  </td>

                                  <td
                                    class="has-text-centered"
                                    v-if="combine.PREPAREID === prepare.ID"
                                  >
                                    <table
                                      class="table is-fullwidth is-narrow is-small"
                                    >
                                      <thead>
                                        <tr>
                                          <th
                                            class="has-text-left "
                                            width="60%"
                                          >
                                            ສິນຄ້າຍ່ອຍ
                                          </th>
                                          <th
                                            class="has-text-right"
                                            width="40%"
                                          >
                                            ຈຳນວນ
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr
                                          v-for="combinedetail in completecombineorderdetail"
                                          :key="combinedetail.DETAILID"
                                        >
                                          <td
                                            v-if="
                                              prepare.ID ===
                                                combinedetail.PREPAREID &&
                                                combine.PREPAREID ===
                                                  prepare.ID &&
                                                combinedetail.PRODUCTID ===
                                                  combine.PRODUCTID
                                            "
                                          >
                                            {{ combinedetail.PRODUCTNAME_SUB }}
                                          </td>
                                          <td
                                            class="has-text-right"
                                            v-if="
                                              prepare.ID ===
                                                combinedetail.PREPAREID &&
                                                combine.PREPAREID ===
                                                  prepare.ID &&
                                                combinedetail.PRODUCTID ===
                                                  combine.PRODUCTID
                                            "
                                          >
                                            ລວມ: {{ combinedetail.QUANTITY }}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            colspan="2"
                                            class="has-text-right"
                                          >
                                            {{ combine.QUANTITY }}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3"><hr /></td>
                        </tr>
                      </tbody>
                    </table>
                  </b-field>
                </div>
              </div>
            </div>
          </b-field>
        </b-tab-item>
        <b-tab-item label="ລາຍລະອຽດກ່ອນພິມ">
          <b-field v-if="1 === 0">
            <button class="button is-info" @click="gotomarketlist">
              ເລືອກ Order ກ່ອນ
            </button>
          </b-field>
          <b-field v-else>
            <div class="contain">
              <div class="columns">
                <div class="column"></div>
                <div class="column">
                  <div style="margin-top: 0px; text-align: center;">
                    <b-field label="ໃບຈັດຊື້"></b-field>
                  </div>
                  <div>ເລກທີກະກຽມ: {{ prepareidforprint.ID }}</div>
                  <div>orderids: {{ prepareidforprint.ORDRERIDLIST }}</div>
                  <div>
                    <button class="button is-success is-small" @click="print()">
                      ພິມໃບຈັດຊື້
                    </button>
                  </div>
                  <div>
                    <table class="table is-fullwidth is-narrow is-small">
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="5%">#</th>
                          <th class="has-text-left " width="95%">
                            ສິນຄ້າ
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(combine, index) in combineorderforprint"
                          :key="combine.ID"
                        >
                          <td class="has-text-centered">{{ index + 1 }}</td>
                          <td>
                            {{ combine.PRDODUCTNAME }}
                            <br />
                            <table
                              class="table is-fullwidth is-narrow is-small"
                            >
                              <tbody>
                                <tr
                                  v-for="combinedetail in combineorderdetailforprint"
                                  :key="combinedetail.DETAILID"
                                >
                                  <td
                                    v-if="
                                      combinedetail.PRODUCTID ===
                                        combine.PRODUCTID
                                    "
                                  >
                                    {{ combinedetail.PRODUCTNAME_SUB }}
                                  </td>
                                  <td
                                    class="has-text-right"
                                    v-if="
                                      combinedetail.PRODUCTID ===
                                        combine.PRODUCTID
                                    "
                                  >
                                    {{ combinedetail.QUANTITY }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="has-text-right" colspan="2">
                                    ລວມ:
                                    {{ combine.QUANTITY | formatNumberLocal }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="column"></div>
              </div>
            </div>
          </b-field>
        </b-tab-item>
      </b-tabs>
    </div>

    <div class="contain print-only page-break">
      <div class="contain">
        <div class="columns">
          <div class="column">
            <div style="margin-top: 0px; text-align: center;">
              <div style="font-size: 14px; font-weight: 900">
                ໃບຈັດຊື້ສິນຄ້າ (Receipt)
              </div>
              <div style="font-size: 12px;">{{ marketname }}</div>
            </div>
            <div style="font-size: 12px;">
              ເລກທີກະກຽມ: {{ prepareidforprint.ID }}
            </div>
            <div style="font-size: 12px;">
              ເລກທີສັ່ງຊື້: {{ prepareidforprint.ORDRERIDLIST }}
            </div>
            <div>
              <table class="table print_table">
                <thead>
                  <tr class="">
                    <th class="has-text-centered " width="5%">#</th>
                    <th class="has-text-left " width="95%">
                      ສິນຄ້າ
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class=""
                    v-for="(combine, index) in combineorderforprint"
                    :key="combine.ID"
                  >
                    <td class="has-text-centered">{{ index + 1 }}</td>
                    <td>
                      {{ combine.PRDODUCTNAME }}
                      <br />
                      <table class="table is-fullwidth is-narrow is-small">
                        <tbody>
                          <tr
                            v-for="combinedetail in combineorderdetailforprint"
                            :key="combinedetail.DETAILID"
                          >
                            <td
                              class="print_td"
                              v-if="
                                combinedetail.PRODUCTID === combine.PRODUCTID
                              "
                            >
                              {{ combinedetail.PRODUCTNAME_SUB }}
                            </td>
                            <td
                              class="has-text-right print_td"
                              v-if="
                                combinedetail.PRODUCTID === combine.PRODUCTID
                              "
                            >
                              {{ combinedetail.QUANTITY }}
                            </td>
                          </tr>
                          <tr class="print_tr">
                            <td class="has-text-right print_td" colspan="2">
                              ລວມ: {{ combine.QUANTITY | formatNumberLocal }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import moment from "moment";

export default {
  data() {
    return {
      userName: null,
      roleid: null,
      marketlist: [],
      inactivemarkets: [],
      marketid: null,
      marketname: null,

      activeTab: 0,
      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,

      orderlist: [],
      orderdertaillist: [],

      preparelist: [],
      combineorder: [],
      combineorderdetail: [],

      completepreparelist: [],
      completecombineorder: [],
      completecombineorderdetail: [],

      prepareidforprint: [],
      combineorderforprint: [],
      combineorderdetailforprint: [],
    };
  },
  methods: {
    getMarkets() {
      RestAPI.getMarketOnline()
        .then((res) => {
          // console.log("list:" + JSON.stringify(res.data));
          this.marketlist = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    gotomarketlist() {
      this.activeTab = 0;
    },
    openOderlistTab(ID, NAME) {
      this.getMarketOnlineOrder(ID);
      this.marketid = ID;
      this.marketname = NAME;
      this.activeTab = 1;
      this.clearPrintdata();
    },
    getMarketOnlineOrder(marketid) {
      RestAPI.getMarketOnlineOrder(marketid)
        .then((res) => {
          // console.log("res.data.order: "+ JSON.stringify(res.data.order))
          this.orderlist = res.data.order;
          this.orderdertaillist = res.data.orderdetail;
          this.getMarketOnlineOrderDetail();
          this.getMarketOnlineOrderCompleteDetail();
          this.clearPrintdata();
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    combineOrders() {
      var params = {
        orderlist: this.orderlist,
        marketid: this.marketid,
        username: this.username,
      };

      RestAPI.combineOrders(params)
        .then(() => {
          // console.log("res:" + JSON.stringify(res.data))
          this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
          this.getMarketOnlineOrder(this.marketid);
          this.getMarketOnlineOrderDetail();
          this.activeTab = 2;
          this.clearPrintdata();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    saveTotal(prepareid) {
      var params = {
        prepareid: prepareid,
        combine: this.combineorder,
        username: this.username,
      };

      console.log("pararms: " +JSON.stringify(params))

      for (var i = 0; i < this.combineorder.length; i++) {
        if (!this.combineorder[i].hasOwnProperty('TOTAL') || this.combineorder[i]['TOTAL'] === null || this.combineorder[i]['TOTAL']<=0) {
          this.$swal("ປ້ອນຈຳນວນເງິນໃຫ້ຄົບ", "", "warning");
          break;
        }
      }

      RestAPI.saveTotal(params)
        .then(() => {
          
          this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
          this.getMarketOnlineOrder(this.marketid);
          this.getMarketOnlineOrderDetail();
          this.getMarketOnlineOrderCompleteDetail();
          this.activeTab = 2;
          this.clearPrintdata();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    cancelTotal(prepareid) {
      var params = {
        prepareid: prepareid,
        username: this.username,
      };

      RestAPI.cancelTotal(params)
        .then(() => {
          
          this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
          this.getMarketOnlineOrder(this.marketid);
          this.getMarketOnlineOrderDetail();
          this.getMarketOnlineOrderCompleteDetail();
          this.activeTab = 2;
          this.clearPrintdata();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    completeCombineOrders(prepareid) {
      var stop = 0;
      for (var i = 0; i < this.combineorder.length; i++) {
        if (!this.combineorder[i].hasOwnProperty('TOTAL') || this.combineorder[i]['TOTAL'] === null || this.combineorder[i]['TOTAL']<=0) {
          this.$swal("ປ້ອນຈຳນວນເງິນໃຫ້ຄົບ", "", "warning");
          stop = 1;
          break;
        }
      }

      if(stop==0){
        var params = {
          prepareid: prepareid,
          username: this.username,
        };

        RestAPI.completeCombineOrders(params)
          .then(() => {
            this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
            this.getMarketOnlineOrder(this.marketid);
            this.getMarketOnlineOrderDetail();
            this.getMarketOnlineOrderCompleteDetail();
            this.activeTab = 2;
            this.clearPrintdata();
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
      
    },

    cancelCombineOrders(prepareid) {
      var params = {
        prepareid: prepareid,
        username: this.username,
      };

      RestAPI.cancelCombineOrders(params)
        .then(() => {
          this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
          this.getMarketOnlineOrder(this.marketid);
          this.getMarketOnlineOrderDetail();
          this.activeTab = 2;
          this.clearPrintdata();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    cancelCombineOrdersForever(prepareid) {
      this.$swal({
        title: "ຕ້ອງການຍົກເລີກລາຍການຖາວອນ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            prepareid: prepareid,
            username: this.username,
          };

          RestAPI.cancelCombineOrdersForever(params)
            .then(() => {
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.getMarketOnlineOrder(this.marketid);
              this.getMarketOnlineOrderDetail();
              this.activeTab = 2;
              this.clearPrintdata();
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    getMarketOnlineOrderDetail() {
      RestAPI.getMarketOnlineOrderDetail(this.marketid)
        .then((res) => {
          // console.log("marketid: " + this.marketid)
          // console.log("getMarketOnlineOrderDetail: " + JSON.stringify(res.data))
          this.preparelist = res.data.prepare;
          this.combineorder = res.data.combineorder;
          this.combineorderdetail = res.data.combineorderdetail;
          this.clearPrintdata();
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getMarketOnlineOrderCompleteDetail() {
      RestAPI.getMarketOnlineOrderCompleteDetail(this.marketid)
        .then((res) => {
          // console.log(" res.data.combineorder: " +  JSON.stringify(res.data.combineorder));
          // console.log("getMarketOnlineOrderDetail: " + JSON.stringify(res.data))
          this.completepreparelist = res.data.prepare;
          this.completecombineorder = res.data.combineorder;
          this.completecombineorderdetail = res.data.combineorderdetail;
          this.clearPrintdata();
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getMarketOnlineOrderDetailbyPrepareid(prepareid) {
      RestAPI.getMarketOnlineOrderDetailbyPrepareid(prepareid)
        .then((res) => {
          // console.log("res.data.combineorderdetail: " + JSON.stringify(res.data.combineorderdetail))
          this.activeTab = 4;
          this.prepareidforprint = res.data.prepare;
          this.combineorderforprint = res.data.combineorder;
          this.combineorderdetailforprint = res.data.combineorderdetail;
          // console.log("prepareidforprint: " +  this.prepareidforprint)
          // this.print();
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    clearPrintdata() {
      this.prepareidforprint = [];
      this.combineorderforprint = [];
      this.combineorderdetailforprint = [];
    },

    printReceipt(prepareid) {
      this.getMarketOnlineOrderDetailbyPrepareid(prepareid);
    },

    print() {
      window.print();
    },
  },
  mounted() {
    // console.log("this.user.BRANCHPROVNICEID: " + JSON.stringify(this.user));
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvinceID = this.user.BRANCHPROVNICEID
      ? this.user.BRANCHPROVNICEID
      : "all";
    this.getMarkets();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.very-important-title {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 40px;
}

/* .paymentdetailselected {
  margin-top: 5px;
  margin-bottom: 5px;
}
.paymentdetailselectedhightlight {
  font-weight: bold;
} */

.print-receipt {
  font-size: 10px;
}
.print-receipt-titel {
  font-size: 12px;
}
.print_table {
  font-size: 10px;
}
.print_tr {
  padding: 0px 0px 0px 0px;
}
.print_td {
  padding: 0px 0px 0px 0px !important;
  margin: 0px 0px 0px 0px !important;
  /* font-size: 20px; */
}
@media all {
  .page-break {
    display: none;
  }
}
@media print {
  @page {
    margin: -10px 0px 0px 0px !important;
    padding: -10px 0px 0px 0px !important;
    size: portrait;
  }
  .page-break {
    display: block;
    max-width: 99%;
  }
}
</style>
